import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConfigProvider, theme } from 'antd';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App.tsx';
import { createBaseStore } from 'sama-shared';
import { createPersistConfig } from 'sama-shared/store/persistConfig';
import adminReducer from './features/admin/slices/adminSlice';
import './index.css';

const adminPersistConfig = createPersistConfig('admin', ['selectedTenantId', 'searchFilter']);

const { store, persistor } = createBaseStore(
  { admin: adminReducer },
  { admin: adminPersistConfig }
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor} onBeforeLift={() => {}}>
        <ConfigProvider
          theme={{ algorithm: theme.darkAlgorithm, token: { colorPrimary: '#ff6c00' } }}
        >
          <App />
        </ConfigProvider>
      </PersistGate>
    </Provider>
  </StrictMode>
);
